<div class="p-6">
    <div class="flex items-start gap-3 mb-4">
        <div class="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-blue-50">
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5 text-blue-600">savings</mat-icon>
        </div>
        <div>
            <h2 class="text-base font-semibold text-slate-900">
                {{ 'coinMachines.emptyTitle' | translate: { name: data.machine.paymentTerminalName } }}
            </h2>
            <p class="text-sm text-slate-500 mt-0.5">
                {{ ((data.machine.amountInCents ?? 0) / 100) | currency: 'EUR' : 'symbol-narrow' : '1.2-2' }}
                · {{ data.machine.coinCount ?? 0 }} {{ 'coinMachines.coins' | translate }}
            </p>
        </div>
    </div>

    <label class="text-sm font-medium text-slate-900" for="cash-box-comment">
        {{ 'coinMachines.comment' | translate }}
    </label>
    <textarea id="cash-box-comment" rows="2" maxlength="512"
              class="mt-2 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
              [ngModel]="comment()" (ngModelChange)="comment.set($event)"></textarea>

    <div class="flex justify-end gap-2 mt-5 pt-4 border-t border-slate-100">
        <jjames-button variant="ghost" (clicked)="onCancel()">{{ 'common.cancel' | translate }}</jjames-button>
        <jjames-button variant="primary" (clicked)="onConfirm()">{{ 'coinMachines.emptyConfirm' | translate }}</jjames-button>
    </div>
</div>
